import React from '../../../node_modules/react';
import CardDeckContainer from '../ui/CardDeckContainer';

// Home component to be used in App.js as part of the landing page.
export const Home = () => (
    <div>
        <CardDeckContainer/>
    </div>
)
